module.exports = __webpack_public_path__ + "static/img/welfare.56838eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/welfare.png
// module id = 2jXE
// module chunks = 0